export function formatNames(namesStr) {
  if (!namesStr) return '';

  const names = namesStr.split(',').map((name) => name.trim());
  if (names.length <= 2) {
    return names.join(', ');
  } else {
    return `${names[0]}, ${names[1]} +${names.length - 2}`;
  }
}
